import api from "@modules/api/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { StartConsumerFinancingRequest } from "../types/ConsumerFinancing";
import consumerFinancingQueryKeys from "../consumerFinancingQueryKeys";

const postStartConsumerFinancing = async (
  req: StartConsumerFinancingRequest
) => {
  return api.rawPost(`api/purchases/c2c-financing/start-consumer-financing`, {
    json: req,
  });
};

export default function useStartConsumerFinancingMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postStartConsumerFinancing,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: consumerFinancingQueryKeys.consumerFinancing(),
      });
    },
  });
}
